if($('.type-detail').length){
    $("#p-detail-tabs").length && ($("#p-detail-tabs").append('<li class="shp-tab"><a href="#certifikat-pravosti" class="shp-tab-link" role="tab" data-toggle="tab">'+Certifikata4Cdiamantu+'</a></li>'), $("#tab-content").append('<div id="certifikat-pravosti" class="tab-pane fade" role="tabpanel" />'), $.ajax({type: "POST", url: certifikatUrl, success: function (a) { var t = $(a).find('#content article > div[itemprop="about"]'); null !== t && $("#certifikat-pravosti").html(t)}}));
    $("#p-detail-tabs").length && ($("#p-detail-tabs").append('<li class="shp-tab"><a href="#doprava-a-platba" class="shp-tab-link" role="tab" data-toggle="tab">'+VyrobaDopravaAplatba+'</a></li>'), $("#tab-content").append('<div id="doprava-a-platba" class="tab-pane fade" role="tabpanel" />'), $.ajax({type: "POST", url: vyrobaUrl, success: function (a) { var t = $(a).find('#content article > div[itemprop="about"]'); null !== t && $("#doprava-a-platba").html(t)}}));
    $("#p-detail-tabs").length && ($("#p-detail-tabs").append('<li class="shp-tab"><a href="#darkove-baleni" class="shp-tab-link" role="tab" data-toggle="tab">'+darkoveBaleni+'</a></li>'), $("#tab-content").append('<div id="darkove-baleni" class="tab-pane fade" role="tabpanel" />'), $.ajax({type: "POST", url: darkoveBaleniUrl, success: function (a) { var t = $(a).find('#content article > div[itemprop="about"]'); null !== t && $("#darkove-baleni").html(t)}}));
    $('#productsRelated').insertBefore('.shp-tabs-wrapper.p-detail-tabs-wrapper');
    $('.shp-tab a[href="#productVideos"]').text('Video');
    $('.variant-list-name:contains("'+velikostCentralnihoKamene+'")').html(velikostCentralnihoKameneHtml);
    $('<div class="col-md-8 pull-right detail-souvis"></div>').insertAfter('.type-detail .p-detail-inner div.col-md-4.pull-left');
    $('div#productsRelated').attr('class', 'tab-pane fade active in').appendTo('.type-detail .p-detail-inner  .detail-souvis');
    
    
    $('.in-luxusni-sperky.type-detail .add-to-cart button').text('');
    $('.in-luxusni-sperky.type-detail .descr-info a.chat').clone().appendTo('.add-to-cart button');
    $('.in-luxusni-sperky.type-detail  .price-final').prepend('<span>'+od+'</span>');
    $('.in-prsteny.type-detail  .price-final').prepend('<span>'+od+'</span>');
    $('.in-luxusni-sperky.type-detail:not(".'+skladem+'") .add-to-cart button[type*="submit"]').text(Poptat);
    $('.in-prsteny.type-detail:not(".'+skladem+'") .add-to-cart button[type*="submit"]').text(Poptat);

    $('<h2>'+detailniPopis+'</h2>').prependTo('body.type-detail .descr-text');
    $('.p-detail-inner .price .add-to-cart .btn').text(objednat);
    $('.added_benefits').insertAfter('.p-detail-inner');
    if($('.variant-list').length>0){
        
    }
    else{
        $('.availability span').each(function(){
            if($(this).text().match(skladem).length > 0){
                $('body').addClass(skladem);
            }
            else{
    
            }
        })
    }
    
    $('ul#p-detail-tabs li').each(function(){
        if($(this).text().match(související)){
            $(this).hide();
        }
    })
    $(".add-to-cart").before("<a href='#' class='open-window-send-gift' style='padding-left: 20px;font-size: 14px;'><i class='fas fa-gift' style='margin-right: 5px;'></i> "+poslatTip+"</a>");
    if($(".breadcrumbs #navigation-1 a").text() != kamennyObchod && $(".breadcrumbs #navigation-1 a").text() != darkovyPoukaz && $(".breadcrumbs #navigation-1 a").text() != certifikovaneDiamanty ) 
    $(".add-to-cart").after("<div class='na-miru col-xs-6 col-md-12'><button type='submit' class='btn btn-primary open-window-na-miru'>"+upravitNaMiru+"</button></div>");
    $(".add-to-cart").after("<div class='schuzka col-xs-6 col-md-12'><a href='/domluvit-si-schuzku/' class='btn btn-white'>Domluvit si schůzku</a></div>");
    $(document).on("click", ".open-window-send-gift", function(e){
        e.preventDefault();
        showGift();
    });
    $(document).on("click", ".open-window-na-miru", function(e){
        e.preventDefault();
        showNaMiru();
    });
}

function showGift() {
    $.get("//shoptet.onclck.cz/zlatnictvisalaba.cz/forms/darek/darek.php", {}, function(data) {$.colorbox({"html": data});});
}
    
function showNaMiru() {
    $.get("//shoptet.onclck.cz/zlatnictvisalaba.cz/forms/na-miru/na-miru.php", {}, function(data) {$.colorbox({"html": data});});
}